import React, { Component } from 'react';
import { Youtube, Instagram } from 'lucide-react';
// X (Twitter) Logo Component
const XLogo = (props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props} data-id="element-1706">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-1707" />
  </svg>;
interface FooterProps {
  'data-id'?: string;
}
export const Footer: React.FC<FooterProps> = ({
  'data-id': dataId
}) => {
  const socialLinks = [{
    name: 'X',
    icon: XLogo,
    href: 'https://x.com/kdroov',
    color: 'hover:bg-white/10 hover:border-white/20 hover:text-white'
  }, {
    name: 'YouTube',
    icon: Youtube,
    href: 'https://youtube.com',
    color: 'hover:bg-red-500/10 hover:border-red-400 hover:text-red-400'
  }, {
    name: 'Instagram',
    icon: Instagram,
    href: 'https://instagram.com',
    color: 'hover:bg-pink-500/10 hover:border-pink-400 hover:text-pink-400'
  }];
  return <footer className="relative w-full bg-gradient-to-b from-[#121212] via-[#0f0f0f] to-[#121212] overflow-hidden" data-id="element-1708">
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-8 py-20 md:py-24 lg:py-32" data-id="element-1709">
        <div className="flex flex-col gap-12 md:gap-16" data-id="element-1710">
          {/* Main Content Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12" data-id="element-1711">
            {/* Company Section */}
            <div className="flex flex-col gap-6 md:gap-8" data-id="element-1712">
              <div className="flex flex-col gap-4 md:gap-6" data-id="element-1713">
                <a href="./" className="group inline-flex items-center w-fit focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:ring-offset-4 focus:ring-offset-[#121212] rounded-2xl transition-all duration-300" aria-label="Go to homepage" data-id="element-1714">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dxuXv5AoswiCCU7F4ucVPA/AcquireFlow_Logo_%287%29.svg" alt="AcquireFlow" className="h-12 md:h-16 group-hover:opacity-90 group-hover:scale-[1.03] transition-all duration-300 filter drop-shadow-sm" data-id="element-1715" />
                </a>
                <p className="text-base md:text-lg font-medium text-[#b8bcc8] leading-relaxed max-w-md" data-id="element-1716">
                  AI-powered MLS offers for serious real estate investors.
                </p>
              </div>

              {/* Social Links */}
              <div className="flex flex-col gap-4" data-id="element-1717">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#3ab795]/10 border border-[#3ab795]/20 backdrop-blur-sm w-fit" data-id="element-1718">
                  <div className="w-2 h-2 rounded-full bg-[#3ab795] animate-pulse" data-id="element-1719" />
                  <p className="text-sm font-medium text-[#3ab795] tracking-wide uppercase" data-id="element-1720">
                    Connect With Us
                  </p>
                </div>
                <div className="flex items-center gap-3" data-id="element-1721">
                  {socialLinks.map(({
                  name,
                  icon: Icon,
                  href,
                  color
                }) => <a key={name} href={href} target="_blank" rel="noopener noreferrer" aria-label={`Follow us on ${name}`} className={`group relative w-12 h-12 bg-white/5 border border-white/10 rounded-full flex items-center justify-center shadow-sm hover:shadow-lg hover:-translate-y-1 active:translate-y-0 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:ring-offset-2 focus:ring-offset-[#121212] ${color}`} data-id="element-1722">
                      <Icon className="w-5 h-5 text-[#b8bcc8] group-hover:scale-110 transition-all duration-300" data-id="element-1723" />
                    </a>)}
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="flex flex-col gap-4 md:gap-6" data-id="element-1724">
              <h3 className="text-sm font-bold text-white uppercase tracking-widest" data-id="element-1725">
                Quick Links
              </h3>
              <nav className="flex flex-col gap-3 md:gap-4" aria-label="Quick links navigation" data-id="element-1726">
                {[{
                label: 'Pricing',
                href: '/pricing'
              }, {
                label: 'Contact',
                href: '/contact'
              }, {
                label: 'Terms of Service',
                href: '/terms-and-conditions'
              }, {
                label: 'Privacy Policy',
                href: '/privacy-policy'
              }].map(link => <a key={link.label} href={link.href} className="text-base md:text-lg font-medium text-[#b8bcc8] hover:text-[#3ab795] transition-colors duration-300 focus:outline-none focus:text-[#3ab795] w-fit" data-id="element-1727">
                    {link.label}
                  </a>)}
              </nav>
            </div>

            {/* Contact Information */}
            <div className="flex flex-col gap-4 md:gap-6" data-id="element-1728">
              <h3 className="text-sm font-bold text-white uppercase tracking-widest" data-id="element-1729">
                Contact
              </h3>
              <div className="flex flex-col gap-3 text-base md:text-lg text-[#b8bcc8]" data-id="element-1730">
                <div data-id="element-1731">
                  <p className="font-semibold text-white mb-1" data-id="element-1732">
                    ACQUIRE FLOW LLC
                  </p>
                  <p className="leading-relaxed" data-id="element-1733">
                    254 Chapman Rd, Ste 208 #25827
                    <br data-id="element-1734" />
                    Newark, Delaware 19702 US
                  </p>
                </div>
                <div data-id="element-1735">
                  <a href="mailto:support@acquireflow.ai" className="hover:text-[#3ab795] transition-colors duration-300 block" data-id="element-1736">
                    support@acquireflow.ai
                  </a>
                  <a href="tel:+18052090120" className="hover:text-[#3ab795] transition-colors duration-300 block" data-id="element-1737">
                    +1 805-209-0120
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Legal Links */}
          

          {/* Bottom Bar */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 pt-8 border-t border-white/10" data-id="element-1738">
            <p className="text-sm md:text-base font-medium text-[#b8bcc8] text-center flex items-center gap-2" data-id="element-1739">
              ©2025 AcquireFlow. Built for investors, by investors.
              <span className="text-red-500" data-id="element-1740">❤️</span>
            </p>
          </div>
        </div>
      </div>
    </footer>;
};